import { createContext, useContext, useState, ReactNode } from "react";

const mockPersonas = {
  "Cloud Architect": {
    packages: [
      {
        name: "AWS",
        skills: [
          { name: "EC2", rating: 5, category: "Compute" },
          { name: "S3", rating: 5, category: "Storage" },
          { name: "VPC", rating: 5, category: "Networking & Content Delivery" },
          { name: "Lambda", rating: 5, category: "Compute" },
          { name: "EKS", rating: 5, category: "Containers" },
          {
            name: "CloudFormation",
            rating: 5,
            category: "Management & Governance",
          },
          { name: "RDS", rating: 4, category: "Database" },
          { name: "DynamoDB", rating: 4, category: "Database" },
          {
            name: "IAM",
            rating: 5,
            category: "Security, Identity & Compliance",
          },
          {
            name: "Route 53",
            rating: 5,
            category: "Networking & Content Delivery",
          },
          {
            name: "CloudFront",
            rating: 4,
            category: "Networking & Content Delivery",
          },
          {
            name: "API Gateway",
            rating: 4,
            category: "Networking & Content Delivery",
          },
          { name: "ELB", rating: 5, category: "Networking & Content Delivery" },
          { name: "Aurora", rating: 4, category: "Database" },
          { name: "ElastiCache", rating: 4, category: "Database" },
        ],
      },
      {
        name: "Microsoft Azure",
        skills: [
          { name: "Virtual Machines", rating: 4, category: "Compute" },
          { name: "Azure Functions", rating: 4, category: "Compute" },
          { name: "Azure Storage", rating: 4, category: "Storage" },
          { name: "Azure SQL Database", rating: 4, category: "Database" },
          { name: "Azure Active Directory", rating: 4, category: "Security" },
          {
            name: "Azure Kubernetes Service",
            rating: 4,
            category: "Containers",
          },
        ],
      },
      {
        name: "DevOps",
        skills: [
          { name: "Terraform", rating: 5, category: "Infrastructure as Code" },
          { name: "Docker", rating: 5, category: "Containerization" },
          {
            name: "Kubernetes",
            rating: 5,
            category: "Container Orchestration",
          },
          { name: "Jenkins", rating: 4, category: "CI/CD" },
          { name: "Git", rating: 5, category: "Version Control" },
          { name: "Ansible", rating: 4, category: "Configuration Management" },
        ],
      },
      {
        name: "Google Cloud",
        skills: [
          { name: "Compute Engine", rating: 4, category: "Compute" },
          { name: "Cloud Functions", rating: 4, category: "Compute" },
          { name: "Cloud Storage", rating: 4, category: "Storage" },
          { name: "BigQuery", rating: 3, category: "Analytics" },
          { name: "Cloud SQL", rating: 4, category: "Database" },
          { name: "GKE", rating: 4, category: "Containers" },
        ],
      },
      {
        name: "Databases",
        skills: [
          { name: "PostgreSQL", rating: 5, category: "Relational" },
          { name: "MySQL", rating: 5, category: "Relational" },
          { name: "MongoDB", rating: 4, category: "NoSQL" },
          { name: "Redis", rating: 4, category: "Caching" },
          { name: "Elasticsearch", rating: 3, category: "Search" },
        ],
      },
      {
        name: "Networking",
        skills: [
          { name: "TCP/IP", rating: 5, category: "Protocols" },
          { name: "DNS", rating: 5, category: "Infrastructure" },
          { name: "Load Balancing", rating: 5, category: "Architecture" },
          { name: "VPN", rating: 4, category: "Security" },
          { name: "CDN", rating: 4, category: "Performance" },
          { name: "API Gateway", rating: 5, category: "Architecture" },
        ],
      },
      {
        name: "Agile",
        skills: [
          { name: "Scrum", rating: 4, category: "Methodologies" },
          { name: "Kanban", rating: 4, category: "Methodologies" },
          { name: "Sprint Planning", rating: 4, category: "Planning" },
          {
            name: "Retrospectives",
            rating: 4,
            category: "Continuous Improvement",
          },
        ],
      },
    ],
    certifications: [
      {
        name: "AWS Certified Solutions Architect - Professional",
        number: "AWS-SAP-12345",
        issueDate: "2023-06-15",
        expiryDate: "2026-06-15",
      },
      {
        name: "AWS Certified Security - Specialty",
        number: "AWS-SEC-67890",
        issueDate: "2024-01-10",
        expiryDate: "2027-01-10",
      },
    ],
  },
  "Junior Developer": {
    packages: [
      {
        name: "AWS",
        skills: [
          { name: "EC2", rating: 3, category: "Compute" },
          { name: "S3", rating: 4, category: "Storage" },
          { name: "Lambda", rating: 3, category: "Compute" },
          { name: "RDS", rating: 3, category: "Database" },
          {
            name: "CloudWatch",
            rating: 3,
            category: "Management & Governance",
          },
          {
            name: "IAM",
            rating: 2,
            category: "Security, Identity & Compliance",
          },
          {
            name: "API Gateway",
            rating: 3,
            category: "Networking & Content Delivery",
          },
        ],
      },
      {
        name: "Programming Languages",
        skills: [
          { name: "JavaScript", rating: 4, category: "Frontend" },
          { name: "Python", rating: 3, category: "Backend" },
          { name: "HTML", rating: 4, category: "Frontend" },
          { name: "CSS", rating: 3, category: "Frontend" },
        ],
      },
    ],
    certifications: [
      {
        name: "AWS Certified Cloud Practitioner",
        number: "AWS-CCP-11111",
        issueDate: "2024-09-01",
        expiryDate: "2027-09-01",
      },
    ],
  },
  "DevOps Engineer": {
    packages: [
      {
        name: "AWS",
        skills: [
          { name: "CodePipeline", rating: 5, category: "Developer Tools" },
          { name: "CodeBuild", rating: 5, category: "Developer Tools" },
          { name: "CodeDeploy", rating: 5, category: "Developer Tools" },
          {
            name: "CloudFormation",
            rating: 5,
            category: "Management & Governance",
          },
          { name: "ECS", rating: 5, category: "Containers" },
          { name: "ECR", rating: 5, category: "Containers" },
          {
            name: "CloudWatch",
            rating: 5,
            category: "Management & Governance",
          },
          {
            name: "Systems Manager",
            rating: 4,
            category: "Management & Governance",
          },
          { name: "Lambda", rating: 4, category: "Compute" },
          { name: "EC2", rating: 5, category: "Compute" },
          {
            name: "IAM",
            rating: 4,
            category: "Security, Identity & Compliance",
          },
          { name: "X-Ray", rating: 4, category: "Developer Tools" },
        ],
      },
      {
        name: "DevOps",
        skills: [
          { name: "Terraform", rating: 5, category: "Infrastructure as Code" },
          { name: "Docker", rating: 5, category: "Containerization" },
          {
            name: "Kubernetes",
            rating: 5,
            category: "Container Orchestration",
          },
          { name: "Jenkins", rating: 5, category: "CI/CD" },
          { name: "Git", rating: 5, category: "Version Control" },
          { name: "Ansible", rating: 4, category: "Configuration Management" },
          { name: "Prometheus", rating: 4, category: "Monitoring" },
          { name: "Grafana", rating: 4, category: "Monitoring" },
        ],
      },
    ],
    certifications: [
      {
        name: "AWS Certified DevOps Engineer - Professional",
        number: "AWS-DOP-22222",
        issueDate: "2023-11-20",
        expiryDate: "2026-11-20",
      },
    ],
  },
  "Data Scientist": {
    packages: [
      {
        name: "AWS",
        skills: [
          { name: "SageMaker", rating: 5, category: "Machine Learning" },
          { name: "Bedrock", rating: 4, category: "Machine Learning" },
          { name: "S3", rating: 5, category: "Storage" },
          { name: "Athena", rating: 4, category: "Analytics" },
          { name: "Glue", rating: 4, category: "Analytics" },
          { name: "Rekognition", rating: 4, category: "Machine Learning" },
          { name: "Comprehend", rating: 4, category: "Machine Learning" },
          { name: "Lambda", rating: 4, category: "Compute" },
          { name: "Kinesis", rating: 3, category: "Analytics" },
          { name: "EMR", rating: 3, category: "Analytics" },
          { name: "Redshift", rating: 3, category: "Database" },
        ],
      },
      {
        name: "AI",
        skills: [
          { name: "TensorFlow", rating: 5, category: "Deep Learning" },
          { name: "PyTorch", rating: 4, category: "Deep Learning" },
          { name: "Scikit-learn", rating: 5, category: "Machine Learning" },
          { name: "Pandas", rating: 5, category: "Data Analysis" },
          { name: "NumPy", rating: 5, category: "Data Analysis" },
          { name: "Jupyter", rating: 5, category: "Development Tools" },
        ],
      },
      {
        name: "Python",
        skills: [
          { name: "Python", rating: 5, category: "Core Language" },
          { name: "FastAPI", rating: 4, category: "Web Frameworks" },
          { name: "Flask", rating: 4, category: "Web Frameworks" },
        ],
      },
    ],
    certifications: [
      {
        name: "AWS Certified Machine Learning - Specialty",
        number: "AWS-MLS-33333",
        issueDate: "2024-03-15",
        expiryDate: "2027-03-15",
      },
    ],
  },
  "Security Engineer": {
    packages: [
      {
        name: "AWS",
        skills: [
          {
            name: "IAM",
            rating: 5,
            category: "Security, Identity & Compliance",
          },
          {
            name: "GuardDuty",
            rating: 5,
            category: "Security, Identity & Compliance",
          },
          {
            name: "Security Hub",
            rating: 5,
            category: "Security, Identity & Compliance",
          },
          {
            name: "WAF",
            rating: 5,
            category: "Security, Identity & Compliance",
          },
          {
            name: "Shield",
            rating: 4,
            category: "Security, Identity & Compliance",
          },
          {
            name: "KMS",
            rating: 5,
            category: "Security, Identity & Compliance",
          },
          {
            name: "Secrets Manager",
            rating: 5,
            category: "Security, Identity & Compliance",
          },
          {
            name: "CloudTrail",
            rating: 5,
            category: "Security, Identity & Compliance",
          },
          {
            name: "Config",
            rating: 5,
            category: "Security, Identity & Compliance",
          },
          {
            name: "Macie",
            rating: 4,
            category: "Security, Identity & Compliance",
          },
          {
            name: "Inspector",
            rating: 4,
            category: "Security, Identity & Compliance",
          },
          {
            name: "Detective",
            rating: 3,
            category: "Security, Identity & Compliance",
          },
        ],
      },
      {
        name: "Cybersecurity",
        skills: [
          { name: "SIEM", rating: 5, category: "Security Operations" },
          {
            name: "Penetration Testing",
            rating: 4,
            category: "Security Testing",
          },
          {
            name: "Vulnerability Assessment",
            rating: 5,
            category: "Security Testing",
          },
          {
            name: "Incident Response",
            rating: 5,
            category: "Security Operations",
          },
          {
            name: "Threat Intelligence",
            rating: 4,
            category: "Security Operations",
          },
          {
            name: "Zero Trust Architecture",
            rating: 4,
            category: "Security Architecture",
          },
        ],
      },
    ],
    certifications: [
      {
        name: "AWS Certified Security - Specialty",
        number: "AWS-SEC-44444",
        issueDate: "2023-08-10",
        expiryDate: "2026-08-10",
      },
    ],
  },
};

interface MockDataContextType {
  mockEnabled: boolean;
  toggleMock: () => void;
  currentPersona: keyof typeof mockPersonas;
  setPersona: (persona: keyof typeof mockPersonas) => void;
  getMockData: () => (typeof mockPersonas)[keyof typeof mockPersonas];
  getMockPackages: () => Array<{
    name: string;
    skills: Array<{ name: string; rating: number; category: string }>;
  }>;
}

const MockDataContext = createContext<MockDataContextType | undefined>(
  undefined,
);

export function MockDataProvider({ children }: { children: ReactNode }) {
  const [mockEnabled, setMockEnabled] = useState(false);
  const [currentPersona, setCurrentPersona] =
    useState<keyof typeof mockPersonas>("Cloud Architect");

  const toggleMock = () => setMockEnabled(!mockEnabled);
  const setPersona = (persona: keyof typeof mockPersonas) =>
    setCurrentPersona(persona);
  const getMockData = () => mockPersonas[currentPersona];
  const getMockPackages = () => mockPersonas[currentPersona].packages;

  return (
    <MockDataContext.Provider
      value={{
        mockEnabled,
        toggleMock,
        currentPersona,
        setPersona,
        getMockData,
        getMockPackages,
      }}
    >
      {children}
    </MockDataContext.Provider>
  );
}

export function useMockData() {
  const context = useContext(MockDataContext);
  if (!context)
    throw new Error("useMockData must be used within MockDataProvider");
  return context;
}
